import { render, staticRenderFns } from "./SelectOrga.vue?vue&type=template&id=21957dd0&scoped=true"
import script from "./SelectOrga.vue?vue&type=script&lang=js"
export * from "./SelectOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21957dd0",
  null
  
)

export default component.exports